import * as accountPage from './pages/account'
import * as appsPage from './pages/apps'
import * as authPage from './pages/auth'
import * as billingPage from './pages/billing'
import * as customPage from './pages/custom'
import * as integratePage from './pages/integrate'
import * as libraryPage from './pages/library'
import * as notificationsPage from './pages/notifications'
import * as supportPage from './pages/support'
import * as usagePage from './pages/usage'
import * as utilityPage from './pages/utility'

export default {
  vendorInvite: {
    title: '您受邀加入 Spatius Studio',
    description: '创建由 {vendor} 管理的全新 Studio 账户。',
    disclosure: '{vendor} 可以只读查看您的账户 ID、显示名称和邮箱地址；自定义 Avatar 的名称、ID 和缩略图；以及套餐、订阅状态、最大并发会话数和最长会话时长。对方无法访问 Avatar 资产或修改您的账户。',
    existing: '已有 Studio 账户？请联系 Spatius 将账户关联至合作伙伴。',
    signedIn: '您当前登录的账户为 {email}。邀请仅用于创建新账户，请先退出登录。',
    signOut: '退出登录并继续',
    continue: '继续创建账户',
    normalLogin: '不使用此邀请，正常登录',
    recoveryTitle: '请重新打开邀请链接',
    recoveryDescription: '请重新打开原始邀请链接，继续创建由合作伙伴管理的账户。如需退出本次邀请，请选择不使用此邀请登录。',
    finishSetup: '完成账户设置',
    setupSignIn: '已完成设置？前往登录',
    verificationDescription: '请输入 {email} 邮箱中的验证码，然后设置并确认您的 Spatius 账户密码，以完成合作伙伴托管账户的设置。',
    verificationReady: '可以继续设置账户了。请使用邮件中的验证码，或重新获取验证码。',
    registrationPassword: '设置您的 Spatius 账户密码',
    verificationRetry: '请获取新的验证码，并重新输入密码后重试账户设置。',
    missing: '请打开原始邀请链接以继续。',
    unavailable: '此邀请不可用，请向合作伙伴申请新的链接。',
    used: '此邀请已被使用，请登录您的 Studio 账户。',
    managedBy: '由 {vendor} 管理',
  },
  common: {
    welcome: '欢迎',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    email: '邮箱地址',
    password: '密码',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    confirmPassword: '确认密码',
    username: '用户名',
    nickname: '昵称',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    submit: '提交',
    cancel: '取消',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    required: '必填',
    optional: '可选',
    back: '返回',
    next: '下一步',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    filter: '筛选',
    reset: '重置',
    actions: '操作',
    copyright: '© 2026 SPATIALWALK PTE. LTD., operating Spatius. 版权所有。',
    studio: 'Studio',
    welcomeToStudio: '欢迎使用 Spatius Studio',
    redirecting: '正在跳转...',
    console: '控制台',
    getStarted: '开始使用',
    learnMore: '了解更多',
    confirm: '确认',
    thisAvatar: '此角色',
    retry: '重试',
  },
  home: {
    hero: {
      title: 'Spatius Studio',
      subtitle: '为开发者提供强大的 AI 数字人服务',
      description: '提供客户端、Web 端、服务端 SDK，轻松接入 AI 数字人能力，开启您的数字形象之旅',
      login: '登录',
      console: '进入控制台',
    },
    features: {
      title: 'Studio 功能',
      subtitle: '我们提供的核心能力',
      sdk: {
        title: '全平台 SDK',
        description: '提供客户端、Web 端、服务端 SDK，支持快速集成',
        client: {
          title: '客户端 SDK',
          description: '支持 iOS、Android 平台，轻松集成到移动应用中',
        },
        web: {
          title: 'Web 端 SDK',
          description: '支持浏览器端集成，提供流畅的 Web 体验',
        },
        server: {
          title: '服务端 SDK',
          description: '提供多种语言的服务端 SDK，支持后端集成',
        },
      },
      ai: {
        title: 'AI 数字人服务',
        description: '强大的 AI 数字人能力，支持实时交互和个性化定制',
        realtime: {
          title: '实时交互',
          description: '毫秒级响应，流畅的自然对话体验',
        },
        avatar: {
          title: '数字形象',
          description: '超写实的 3D 数字形象，支持多样化定制',
        },
        voice: {
          title: '语音同步',
          description: '精准的音素同步，完美匹配口型与语音',
        },
      },
    },
    sdk: {
      title: '全平台 SDK 支持',
      subtitle: '选择适合您的平台，快速开始集成',
      quickStart: '快速开始',
      docs: '查看文档',
    },
    cta: {
      title: '开始您的数字形象之旅',
      subtitle: '立即注册账号，开始使用 Spatius Studio',
      register: '立即注册',
      login: '已有账号？立即登录',
    },
  },
  auth: {
    title: {
      login: '欢迎回来',
      register: '创建账号',
    },
    subtitle: {
      login: '输入密码继续。',
      register: '看起来你是新用户——设个密码我们就帮你开始。',
    },
    welcome: {
      title: '欢迎使用 Spatius',
      subtitle: '我们将为您登录，如果您还没有账号，我们会为您创建一个。',
      emailPlaceholder: '请输入您的邮箱',
      continue: '继续',
      or: '或',
      terms: '继续使用即表示您同意{terms}，并确认您已阅读{privacy}',
      termsText: '服务条款',
      privacyText: '隐私政策',
    },
    email: {
      label: '邮箱地址',
      placeholder: '请输入您的邮箱',
      useAnother: '换个邮箱',
    },
    password: {
      label: '密码',
      placeholder: '请输入您的密码',
      newPlaceholder: '请输入新密码',
      confirmPlaceholder: '请再次输入新密码',
      minLength: '至少 8 位字符',
      confirm: '再次输入密码',
    },
    username: {
      label: '用户名（可选）',
      placeholder: 'username',
    },
    nickname: {
      label: '昵称（可选）',
      placeholder: 'nickname',
    },
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loginButton: '登录',
    registerButton: '创建账号',
    loggingIn: '登录中...',
    registering: '注册中...',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功',
    loginError: '登录失败',
    registerError: '注册失败',
    noAccount: '还没有账号？',
    haveAccount: '已有账号？',
    signUp: '立即注册',
    signIn: '立即登录',
    signin: {
      errorInvalid: '邮箱或密码错误。',
      signupPrompt: '还没有 Spatius 账号？',
      signupAction: '立即注册 →',
    },
    signup: {
      title: '注册',
      allFieldsRequired: '/所有字段必填',
      namePlaceholder: '您的姓名',
      passwordStrength: '密码强度',
      agreeToTerms: '我已阅读并同意{privacy}、{terms}和数据处理协议。',
      termsText: '服务条款',
      privacyText: '隐私政策',
      failed: '注册失败，请重试。',
      signInToContinue: '请尝试登录以继续，或使用其他邮箱。',
      continueSignIn: '继续登录',
    },
    verify: {
      title: '创建您的账号',
      titleReset: '重置您的密码',
      subtitle: '我们已向您发送了验证码。请查看您的收件箱 {email}。',
      resendCode: '重新发送验证码',
      restartSocial: '重新使用 {provider} 登录',
      resendCodeCooldown: '重新发送 ({seconds}秒)',
      verify: '验证',
      invalidCode: '验证码无效',
      error: '验证失败',
      success: '验证成功',
      codeSent: '验证码已发送',
      needVerification: '您的邮箱尚未验证，请先验证邮箱后再登录',
    },
    reset: {
      title: '重置密码',
      subtitle: '请输入您的邮箱以重置密码。',
      button: '重置密码',
      sent: '重置密码邮件已发送',
      error: '发送重置密码邮件失败',
    },
    resetPassword: {
      title: '重置密码',
      subtitle: '请输入您的新密码',
      button: '重置密码',
      success: '密码重置成功，正在跳转到登录页...',
      invalidToken: '无效或已过期的重置令牌',
      backToLogin: '返回登录',
    },
    oauth: {
      github: '使用 GitHub 登录',
      google: '使用 Google 登录',
      connecting: '连接中...',
      error: '第三方登录失败: {error}',
      divider: '或使用邮箱登录',
      registerDivider: '或使用邮箱注册',
      quickLogin: '使用第三方账号快速登录',
      loginWith: '使用 {provider} 登录',
      securityNote: '我们使用 OAuth 2.0 安全协议，不会获取您的密码信息',
      clientIdNotConfigured: 'Client ID 未配置',
      routeNotImplemented: 'OAuth 登录接口未实现，请联系管理员',
    },
    validation: {
      emailRequired: '请输入邮箱地址',
      passwordRequired: '请输入密码',
      passwordMinLength: '密码长度至少 8 位',
      passwordMismatch: '两次输入的密码不一致',
      turnstileRequired: '请完成人机验证',
      turnstileError: '验证失败，请重试',
    },
  },
  cliAuth: {
    heroTitle: '从这里，开启下一步。',
    heroSubtitle: '将终端连接到 Spatius，让下一个创意成为现实。',
    approvalHint: '请仅批准由你本人发起的请求。批准后，浏览器将返回本地 CLI 会话以完成登录。',

    eyebrow: 'CLI 授权',
    title: '授权 {clientName}',
    subtitle: '请确认此待处理请求，批准后会将 {clientName} CLI 登录到您的 Spatius 账号。',
    loading: '正在加载授权请求...',
    redirecting: '正在跳转到登录页...',
    missingRequest: '未找到授权请求。',
    unknownClient: 'CLI 应用',
    statusReady: '可授权',
    statusApproved: '已授权',
    statusExpired: '已过期',
    statusLabel: '状态',
    clientLabel: '客户端',
    requestIdLabel: '请求 ID',
    expiresLabel: '过期时间',
    accountLabel: '账号',
    expiresAt: '过期时间：{time}',
    accountMissing: '请先登录',
    signedInAs: '当前登录账号：{email}。批准后会将浏览器重定向回本地 CLI，并在那里保存会话。',
    signInHint: '批准此 CLI 授权请求前，需要先登录。',
    approve: '批准并继续',
    approving: '授权中...',
    backToLogin: '去登录',
    retry: '重试',
    refresh: '刷新请求',
    approvedMessage: '此请求已经授权。如果浏览器没有自动跳转，请返回 {clientName}。',
    expiredMessage: '此授权请求已过期，请回到 {clientName} 重新发起登录。',
    successRedirect: '授权成功，正在返回 {clientName}...',
    loadError: '加载授权请求失败',
    approveError: '批准授权请求失败',
    missingRedirect: '缺少 CLI 授权回跳地址。',
    invalidRedirect: 'CLI 授权回跳地址必须指向本地回调服务。',
  },
  error: {
    network: '网络错误',
    unauthorized: '未授权，请重新登录',
    forbidden: '权限不足',
    notFound: '资源未找到',
    serverError: '服务器错误',
    unknown: '未知错误',
  },
  navigation: {
    home: '首页',
    avatars: '数字人',
    avatarLibrary: '角色库',
    customAvatar: '自定义角色',
    createAvatar: '创建角色',
    avatarUnits: 'Avatar Creations',
    account: '账户',
    developer: '开发者',
    integrate: '接入',
    apiKeys: 'API Key',
    stats: '用量',
    connectionLogs: '连接日志',
    settings: '设置',
    documentation: '文档',
    community: '社区',
    website: 'spatius.ai',
    pricing: '定价',
    plan: '计划与账单',
    billing: '账单',
    feedback: '反馈',
  },
  billing: {
    upgradePlan: '升级方案',
    credits: '额度',
    currentPlan: '当前方案',
    renewsOn: '{date} 续费',
    refreshesOn: '{date} 刷新',
    remainingCredit: '剩余额度',
    estimatedRemaining: '预计剩余分钟',
    concurrentSession: '最大并发会话',
    subscriptionManagement: '订阅管理',
    creditsRemaining: '剩余额度',
    left: '剩余',
    remaining: '剩余',
    autoReload: {
      title: '自动充值',
      description: '当额度不足时自动补充。',
      reloadAmount: '充值金额',
      thresholdLabel: '余额低于以下额度时触发',
      summary: '余额低于 {threshold} 时，将通过订阅绑定的付款方式自动充值 {amount}。',
      save: '保存',
      saving: '保存中...',
      saved: '自动充值设置已保存',
    },
  },
  language: {
    zhCN: '中文',
    enUS: 'English',
    switch: '切换语言',
  },
  apiKeys: {
    title: 'API keys',
    subtitle: 'Create and manage your API keys',
    securityInfo: '列表包含您所有的 API Key。请妥善保管，不要与他人共享，也不要暴露在浏览器或其他客户端代码中。为保护账户安全，我们可能会自动禁用被检测到公开泄露的 API Key。',
    securityInfoShort: '请妥善保管 API Key，不要泄露。',
    loading: '加载中...',
    empty: 'No API key available, you can',
    createLink: 'create an API key',
    createButton: 'Create new API key',
    createTitle: 'Create API key',
    selectApp: 'Select Application',
    selectAppPlaceholder: 'Please select an application',
    selectAppRequired: 'Please select an application',
    name: 'Name',
    namePlaceholder: 'Your App Name',
    copyWarning: 'Please copy and save your app secret immediately.',
    copy: 'Copy',
    reveal: 'Reveal',
    hide: 'Hide',
    copySuccess: 'API key copied to clipboard',
    copyFailed: 'Failed to copy API key',
    createSuccess: 'API key created successfully',
    createFailed: '创建 API key 失败，请重试',
    keyNotAvailable: 'API key 不可用',
    delete: 'Delete',
    deleteTitle: 'Delete API key',
    deleteWarning: 'The API key will be disabled immediately. API requests made using this key will be rejected, which may cause any systems still relying on it to crash. Once deleted, you will no longer be able to view or modify this API key',
    deleteNamePrompt: 'Please enter the name of the key to delete :',
    deleteNameHint: 'Enter "{name}" to confirm deletion',
    deleteNameMismatch: 'The name does not match',
    deleteButton: 'Delete this API key',
    deleteSuccess: 'API key deleted successfully',
    table: {
      name: 'Name',
      appSecret: 'API 密钥',
      creationDate: 'Creation date',
      latestUseDate: 'Latest use date',
      manage: 'Manage',
    },
  },
  apiKeyManagement: {
    title: '管理',
    subtitle: '管理应用和 API 密钥',
    create: '创建',
    createTitle: '创建新应用',
    createDesc: '创建一个新的应用来管理 API 密钥',
    createApiKeyCta: 'Create api key',
    createResult: {
      title: 'API 凭据',
      description: '请复制并妥善保存以下凭据。',
      environmentVariable: '环境变量',
      copyField: '复制{field}',
      copiedField: '已复制{field}',
    },
    name: '应用名称',
    namePlaceholder: '输入应用名称',
    nameRequired: '请输入应用名称',
    loading: '加载中...',
    noData: '暂无数据',
    apiKeyCount: 'API Key 数量',
    detailButton: '详情',
    confirmDeleteTitle: '确认删除应用',
    confirmDeleteDesc: '此操作不可撤销，将同时删除该应用下的所有 API Key。',
    confirmDeleteMessage: '确定要删除应用 "{name}" 吗？此操作不可撤销，将同时删除该应用下的所有 API Key。',
    list: {
      empty: '暂无应用',
      emptyDesc: '创建您的第一个应用开始使用',
      appId: '应用 ID',
      name: '应用名称',
      apiKeys: 'API 密钥',
      createdAt: '创建时间',
      actions: '操作',
      view: '管理',
      manageApiKeys: '管理 API 密钥',
      delete: '删除',
      confirmDelete: '确定要删除这个应用吗？',
      deleteSuccess: '应用已删除',
      createSuccess: '应用已创建',
    },
    detail: {
      title: '应用详情',
      subtitle: '管理应用的基本信息和 API Key',
      back: '返回列表',
      backToList: '返回应用列表',
      loading: '加载中...',
      notFound: '应用不存在或已被删除',
      info: '基本信息',
      infoTitle: '应用信息',
      appId: '应用 ID',
      name: '应用名称',
      apiKeyCount: 'API Key 数量',
      createdAt: '创建时间',
      createdAtLabel: '创建时间:',
      apiKeys: 'API Key 列表',
      apiKeysDesc: '管理应用的 API Key',
      createKey: '添加 API Key',
      createKeyTitle: '添加 API Key',
      createKeyDesc: '为应用 "{name}" 创建新的 API Key',
      createKeyMessage: '点击确认后将为此应用生成一个新的 API Key。',
      creating: '创建中...',
      confirmCreate: '确认创建',
      copySuccess: '已复制到剪贴板',
      copyFailed: '复制失败',
      copy: '复制',
      keyList: {
        loading: '加载中...',
        empty: '暂无 API Key，点击上方按钮添加',
        emptyDesc: '创建一个 API 密钥以开始使用',
        key: 'API 密钥',
        createdAt: '创建时间',
        createdBy: '创建者',
        actions: '操作',
        delete: '删除',
        deleteTitle: '删除 API Key',
        confirmDelete: '确定要删除 API Key "{key}" 吗？此操作不可撤销，使用此 API Key 的应用将无法正常工作。',
        confirmDeleteDefault: '确定要删除此 API Key 吗？此操作不可撤销，使用此 API Key 的应用将无法正常工作。',
        deleteSuccess: 'API Key 删除成功',
        deleting: '正在删除',
        deleteFailed: '获取应用信息失败',
        loadFailed: '加载 API 密钥列表失败',
        maskedKey: '••••••••••••••••',
      },
      sessionToken: {
        title: '临时Token',
        warning: '仅供开发调试使用,生产环境请通过服务端生成',
        warningDesc: '此工具生成的 Session Token 用于在未开发后端的情况下跑通 Client SDK 流程。为了安全起见,Token 有效期被强制设定为24小时,且单用户有生成频率限制。',
        generateButton: '生成临时 Token',
        generateHint: '*生成后请立即复制,刷新页面后将丢失',
        sessionToken: 'SESSION TOKEN',
        validUntil: '有效期至',
        validDuration: '24小时',
        copy: '复制',
        regenerate: '重新生成',
        generating: '生成中...',
        generateFailed: '生成失败，请稍后重试',
        noApiKey: '请先创建 API Key 后再生成 Token',
        invalidApiKey: 'API Key 无效',
        copied: '已复制',
      },
    },
  },
  settings: {
    title: '设置',
    description: '管理您的账户设置和偏好配置',
    accountInfo: {
      title: '账户信息',
      description: '查看和管理您的账户信息',
      notLoggedIn: '未登录',
      username: '用户名',
      loginMethod: '登录方式',
      oauthLogin: '第三方登录',
    },
    password: {
      title: '修改密码',
      description: '定期更改密码以确保账户安全',
      security: '密码安全',
      updatePassword: '更新您的账户密码',
      changeButton: '修改密码',
      dialogTitle: '修改密码',
      dialogDescription: '请输入当前密码和新密码',
      oldPassword: '当前密码',
      oldPasswordPlaceholder: '请输入当前密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入新密码（至少8位）',
      confirmPassword: '确认新密码',
      confirmPasswordPlaceholder: '请再次输入新密码',
      allFieldsRequired: '请填写所有字段',
      minLength: '新密码至少需要8个字符',
      mismatch: '两次输入的新密码不一致',
      changeSuccess: '密码修改成功',
      changeFailed: '密码修改失败',
      cancel: '取消',
      confirm: '确认修改',
    },
    language: {
      title: '语言设置',
      description: '选择界面显示语言',
      currentLanguage: '当前语言',
    },
    accountActions: {
      title: '账号操作',
      description: '管理您的账号操作',
      logout: '退出登录',
      logoutDescription: '安全退出您的账户',
      logoutButton: '退出登录',
    },
    logout: {
      success: '已登出',
    },
    comingSoon: {
      title: '更多功能',
      description: '更多设置选项即将推出',
      message: '更多设置功能正在开发中，敬请期待',
    },
  },
  cookie: {
    title: 'Cookie 使用同意',
    description: '我们使用 Cookie 来改善您的浏览体验、分析网站流量并个性化内容。继续使用本网站即表示您同意我们使用 Cookie。',
    accept: '接受',
    reject: '拒绝',
    accepted: '已接受 Cookie 使用',
    rejected: '已拒绝 Cookie 使用。我们将仅使用必要的功能性 Cookie，不会收集分析数据。',
    info: '即使您拒绝 Cookie，我们仍会使用必要的功能性 Cookie 来确保网站正常运行（如登录状态）。',
  },
  avatars: {
    desktopOnly: {
      title: '请在电脑端使用',
      description: '手机端暂不支持创建或预览 Avatar，请在电脑端打开 Studio 继续。',
      confirm: '知道了',
    },
    list: {
      title: '自定义角色',
      subtitle: '管理您的自定义数字人资产',
      createButton: '创建数字人',
      createFromPhoto: '从一张照片开始',
      all: '全部',
      completed: '已完成',
      generating: '生成中',
      failed: '失败',
      public: '公共',
      showPublic: '显示公共数字人',
      loading: '加载资产中...',
      loadMore: '加载更多',
      loadingMore: '加载更多中...',
      noAssets: '暂无资产',
      noAssetsFiltered: '未找到 {filter} 资产',
      generatingAvatar: '生成中的数字人',
      creating: '创建中',
      creatingStageSubmitted: '已提交',
      creatingStagePreparing: '正在准备数字人',
      creatingStageBuilding: '正在构建数字人',
      creatingStageFinalizing: '正在完成数字人',
      creatingStageReady: '可查看',
      creatingStageFailed: '创建未成功',
      creatingSummaryTitleOne: '1 个数字人正在创建',
      creatingSummaryTitleMany: '{count} 个数字人正在创建',
      creatingOverallHint: '大多数数字人会在 3–4 小时内完成。你可以离开本页，稍后再回来查看。',
      creationInProgress: '创建进行中',
      startedJustNow: '刚刚开始',
      startedMinutesAgo: '{count} 分钟前开始',
      startedHoursAgo: '{count} 小时前开始',
      edit: '编辑',
      viewEdit: '查看 / 编辑',
      previewEdit: '预览 / 编辑',
      idCopied: '已复制',
      actionsFor: '{name} 的更多操作',
      view: '查看',
      previewTalk: '预览 / 试聊',
      tuneAvatar: '调整效果',
      tryChat: '试试对话',
      countLabel: '{count} 个数字人',
      copy: '复制',
      duplicate: '复制',
      delete: '删除',
      id: 'ID',
      copyId: '复制 ID: {id}',
      copyIdLabel: '复制 ID',
      copyIdSuccess: '数字人 ID 已复制到剪贴板',
      copyIdFailed: '复制数字人 ID 失败',
      copySuccess: '数字人复制成功',
      copyFailed: '复制数字人失败',
      duplicateSuccess: '数字人复制成功',
      duplicateFailed: '复制数字人失败',
      duplicateTitle: '复制角色',
      duplicateDescription: '确定要复制 "{name}" 吗？将创建一个具有相同设置的新角色。',
      deleteSuccess: '数字人删除成功',
      deleteFailed: '删除数字人失败',
      deleteTitle: '删除角色',
      deleteDescription: '确定要删除 "{name}" 吗？此操作无法撤销。',
      deleteNoRefundTitle: '删除「{name}」',
      deleteGeneratingTitle: '删除正在创建的「{name}」',
      deleteFailedRecordTitle: '移除「{name}」的失败记录',
      deleteNoRefundHeadline: '删除后不会退回 Avatar Creation',
      deleteNoRefundBody: '创建这个数字人时消耗的 Avatar Creation 已经用掉，删除不会返还。只有创建失败才会自动退回。',
      deleteGeneratingBody: '这次创建还在进行中，已消耗的 Avatar Creation 不会退回，删除后也拿不到这个数字人。',
      deleteBalanceUnchanged: '删除后余额仍是 {count} 个，不会增加。',
      deleteIrreversible: '删除后无法恢复。',
      deleteAcknowledge: '我已了解：删除不会退回 Avatar Creation',
      deleteFailedRecordBody: '只是把这条记录从列表里去掉。这次失败消耗的 Avatar Creation 已经自动退回，不影响余额。',
      deleteConfirm: '删除数字人',
      removeRecord: '移除记录',
      download: '下载资产包',
      downloadSuccess: '资产包下载成功',
      downloadFailed: '下载资产包失败',
      fetchFailed: '获取资产失败',
      fetchGeneratingFailed: '获取生成中的数字人失败',
      fetchAvatarsFailed: '获取数字人列表失败',
    },
    publicConversation: {
      dockTitle: '跟这个数字人聊聊',
      dockSubtitle: '官方形象 · {voice}',
      publicAvatar: '公共数字人',
      stageKicker: '01 · 体验',
      stageTitle: '试试这个数字人',
      integrationKicker: '02 · 接入',
      integrationTitle: '在你的应用里使用',
      avatarIdTitle: '数字人 ID',
      backgroundTitle: '背景图',
      integrationNote: '公共形象可直接使用：在你自己的应用里用 AvatarKit 加上面这个 ID 就能驱动。',
      fallbackName: '公共数字人',
      loadingDetails: '正在加载数字人信息...',
      initializing: '正在初始化 AvatarKit...',
      downloading: '正在下载数字人资源...',
      loadingAvatar: '正在加载数字人...',
      creatingView: '正在创建数字人视图...',
      preparing: '正在准备数字人...',
      notFound: '此公共数字人不可用。',
    },
    download: {
      title: '选择清晰度',
      description: '请至少选择一种清晰度（标清、高清、超清）',
      download: '下载',
      quality: {
        sd: '标清',
        hd: '高清',
        uhd: '超清',
      },
    },
    edit: {
      title: '编辑数字人',
      cancel: '取消',
      saving: '保存中...',
      save: '保存',
      avatarPreview: '数字人预览',
      minSdkVersion: '最低 SDK 版本',
      config: '配置',
      postprocess: '后处理',
      reset: '重置',
      avatarId: '资产 1：数字人 ID',
      avatarName: '数字人名称',
      namePlaceholder: '请输入数字人名称',
      dptVersion: 'DPT 版本',
      loading: '加载中...',
      selectDptVersion: '选择 DPT 版本',
      camera: '相机',
      fovY: 'fovY (弧度)',
      translationX: 'translationX (米)',
      translationY: 'translationY (米)',
      translationZ: 'translationZ (米)',
      modelParams: '模型参数（应用于当前帧）',
      eyeBlink: 'eyeBlink',
      expressionWeight: 'expressionWeight',
      rotation: 'rotation (弧度偏移)',
      neckPose: 'neckPose (弧度偏移)',
      jawPose: 'jawPose (弧度偏移)',
      weight: 'weight',
      invalidAvatarId: '无效的数字人 ID',
      avatarNotFound: '数字人未找到',
      unknownAvatar: '未知数字人',
      characterDataAbnormal: '当前角色数据异常，请提交工单',
      pleaseEnterName: '请输入名称',
      savedSuccessfully: '保存成功',
      updateFailed: '更新数字人失败',
      download: '下载资产包',
      downloadSuccess: '资产包下载成功',
      downloadFailed: '下载资产包失败',
      loadFailed: '加载数字人失败',
      backgroundAssetTitle: 'Background',
      backgroundAssetDesc: 'Generated background image.',
      backgroundImageAlt: '自动生成的 16:9 数字人背景图预览',
      showBackground: '显示背景',
      backgroundGuide: '指南',
      downloadBackground: '下载',
      backgroundOpenedInNewTab: '背景图已在新标签页打开',
      postprocessRangeExceeded: '数值超出限制',
      postprocessRangeExceededDescription: '允许范围是 {min} 到 {max}，已调整为 {adjusted}。',
      stage: {
        kicker: '01 · 体验',
        title: '认识你的数字人',
      },
      delivery: {
        kicker: '02 · 交付',
        title: '交付内容',
        forAvatarKit: '用于 AvatarKit',
        copy: '复制',
        copied: '已复制',
        copyFailed: '复制失败',
        backgroundTitle: '资产 2：背景图',
        backgroundMaster: '16:9 原图',
        integrationGuide: '查看接入方式',
        sdkNote: 'AvatarKit 不会自动加载背景。',
        zoomTitle: '16:9 背景原图',
      },
      dock: {
        connectTimeout: '连接超时，请重新开始对话。',
        disconnected: '对话已断开。',
        idleTitle: '跟这个数字人聊聊',
        greetingTitle: '打招呼中…',
        greetingMutedTitle: '打招呼中（已静音）',
        greetingMutedHint: '浏览器拦截了自动播放，点右上角标开启声音',
        startConversation: '开始',
        endConversation: '结束对话',
        connecting: '正在连接…',
        listening: '聆听中，说点什么吧',
        speaking: '正在回应…',
        demoLabel: 'Studio 演示 · {voice}',
        changeVoice: '换个声音',
        muted: '已静音',
        mute: '静音',
        unmute: '取消静音',
        remainingTitle: '本次对话剩余时间',
        remainingAriaLabel: '本次对话剩余时间：{time}',
        endingSoon: '剩余时间不足一分钟',
        timeLimitTitle: '本次对话时间已结束',
        timeLimitDescription: '本次对话的可用时长已结束，连接已断开。你可以随时重新开始对话。',
        timeLimitDetailsLabel: '为什么本次对话已结束？',
        startAgain: '重新开始',
        inputPlaceholder: '不方便说话？打字也行',
        send: '发送',
      },
      demoSetup: {
        kicker: '演示设置',
        title: '选择声音',
        disclaimer: '此设置仅用于 Studio 内的数字人演示。正式接入时，Spatius 不提供 LLM 或 TTS 服务。',
        voice: {
          male: '男声',
          female: '女声',
        },
      },
      pp: {
        kicker: '03 · 优化',
        entryTitle: '后处理',
        collapse: '关闭',
        settingsCount: '3 项设置',
        notice: '建议边对话边调整，直接感受效果。',
        expressiveness: {
          title: '表现力',
          desc: '同时调整表情、头部和口型的运动幅度。',
          less: '更克制',
          default: '默认',
          more: '更鲜明',
        },
        head: {
          title: '头部调整',
          desc: '三个方向分别微调头部基准姿态。',
          tilt: '上下',
          tiltMin: '低头',
          tiltMax: '抬头',
          turn: '左右转向',
          turnMin: '向左看',
          turnMax: '向右看',
          roll: '左右倾斜',
          rollMin: '向左倾',
          rollMax: '向右倾',
        },
        jaw: {
          title: '下颌高度',
          desc: '校正口型基准位置。',
          min: '更低',
          default: '默认',
          max: '更高',
        },
        placement: {
          title: '数字人位置',
          desc: '调整会立即显示，并应用于所有画面比例。',
          scale: '人物大小',
          scaleMin: '更小',
          scaleMax: '更大',
          horizontal: '左右位置',
          horizontalMin: '向左',
          horizontalMax: '向右',
          vertical: '上下位置',
          verticalMin: '向下',
          verticalMax: '向上',
          instant: '即时生效',
        },
      },
      feedback: {
        question: '这个数字人现在有多接近可用？',
        autoAttach: '会自动关联当前 Avatar',
        anchors: {
          0: '完全不可用',
          2: '问题严重',
          4: '需要明显调整',
          6: '已经可以使用',
          8: '效果很出色',
          10: '令人惊艳',
        },
        issueQuestion: '哪里有问题？至少选一项',
        issues: {
          lipSync: '口型不准',
          teeth: '牙齿瑕疵',
          face: '面部瑕疵',
          body: '身体瑕疵',
          background: '背景有问题',
          motion: '动作不自然',
          other: '其他',
        },
        noteLabel: '补充说明',
        notePlaceholder: '简单描述一下具体问题',
        savedHint: '已记录，感谢反馈',
        closeLabel: '关闭评分',
        submit: '提交',
      },
      publicApply: {
        inviteTitle: '效果这么好，要不要公开到形象库？',
        inviteDesc: '通过审核可获得 Avatar Creations 奖励。公开的是一份复制体，你自己的数字人保持私有。',
        inviteDismiss: '先不用',
        inviteGo: '去申请',
        dialogKicker: '申请公开',
        dialogTitle: '公开到形象库',
        explainCopy: '提交后我们会复制一份你的数字人放进公开形象库。',
        explainDrive: '公开后，其他开发者可以使用这份复制体驱动。',
        explainPrivate: '你自己的数字人不会被公开，别人也无法驱动它。公开的那份是审核通过时的状态，你之后调整参数不会同步过去。',
        explainReview: '需要人工审核，通过后发放 Avatar Creations 奖励，结果会在 Feedback 里告诉你。',
        consentStatement: '我已理解并同意：公开后其他开发者可以使用这份复制体驱动。',
        fieldAvatar: 'Avatar',
        cancel: '取消',
        close: '关闭',
        submit: '提交申请',
        submitSuccess: '已提交申请，进度见 Feedback。',
      },
    },
    create: {
      emotion: {
        reviewTitle: '确认并创建',
        ownershipTitle: '资产归属与隐私',
        title: '人物情绪',
        neutral: '中立',
        happy: '开心',
        sad: '悲伤',
        description: '创建后不可直接切换情绪。',
      },
      title: '创建数字人',
      subtitle: '创建新的数字人',
      backToList: '返回列表',
      clickToUpload: '点击上传图片',
      imageFormat: '支持 JPG 或非透明 PNG，最大 10MB',
      materialSuggestions: '素材建议',
      materialSuggestionsDesc: '高分辨率、均匀光照的正面照片。避免佩戴眼镜或刘海遮挡面部特征。',
      viewFullGuide: '查看完整指南',
      clickToEnlarge: '点击放大',
      examples: '示例',
      name: '名称',
      namePlaceholder: '例如：智能助手',
      systemPrompt: '系统提示词',
      systemPromptPlaceholder: '输入角色的系统提示词...',
      aiProcessing: 'AI 处理',
      aiProcessingDesc: '自动调整身体和面部朝向为标准正面姿态，以获得最佳数字人生成效果。',
      portraitRights: '肖像权协议',
      portraitRightsDesc: '我确认有权使用此照片，并同意将其用于创建数字人。',
      createButton: '创建数字人',
      creating: '创建中...',
      cropImage: '图片剪裁',
      cropImageDesc: '请调整图片剪裁区域',
      failedToLoadImage: '加载图片失败',
      failedToReadImage: '读取图片文件失败',
      pleaseSelectImage: '请选择图片文件',
      imageTooLowResolution: '图片分辨率过低（短边不得小于 340px）',
      pleaseEnterName: '请输入数字人名称',
      pleaseEnterPrompt: '请输入系统提示词',
      pleaseUploadImage: '请上传图片',
      pleaseAgreeToTerms: '请确认有权使用此照片，并同意用于创建数字人',
      uploadingImage: '正在上传图片...',
      creatingAvatar: '正在创建数字人...',
      createdSuccessfully: '数字人创建申请已提交。',
      createFailed: '创建数字人失败',
      noImageSelected: '未选择图片',
      comingSoon: '即将推出',
      noPermission: '您没有创建角色的权限',
      limitedBeta: {
        title: 'Create Avatar is currently in limited beta',
        description: 'We are opening 100 complimentary Avatar Creations to selected users and teams during this beta period.',
        instructionsIntro: 'To request access, please email',
        instructionsSuffix: 'and tell us:',
        who: 'Who you are: an individual or a company',
        company: 'Your company name, if applicable',
        useCase: 'How you plan to use Create Avatar',
        response: 'Our team will review your request and get back to you as soon as possible.',
      },
      confirmTitle: '确认创建',
      confirmMessage: '本次创建将消耗 1 个 Avatar Creation。',
      // Draft copy — final wording pending PM review (req 8).
      confirmTimeline: '整个过程约需 3–4 小时，期间可以关闭页面，随时到 Custom Avatars 查看进度。',
      confirmCancel: '取消',
      confirmOk: '确认创建',
      selectEngine: '选择生成引擎',
      baseTemplate: '基础模板',
      baseTemplateDesc: '选择与您上传的角色最匹配的模板。',
      imageSizeLimit: '图片大小不能超过 10MB',
      coreDesc: '适用于标准正面照片 — 面部和身体正对镜头，手不可见。',
      flexDesc: '适用于有手、倾斜姿势或身体未完全正对镜头的照片。',
      presetEastAsianMale: '东亚男性',
      presetLatinFemale: '拉丁裔女性',
      presetMateo: 'Mateo',
      presetWhiteHairedFemale: '白发女性',
      audioPresetEnglishMale: 'Male voice 1',
      audioPresetEnglishFemale: 'Female voice 1',
      audioPresetChineseMale: 'Male voice 2',
      audioPresetChineseFemale: 'Female voice 2',
      preprocess: {
        module: {
          detectDone: '检测通过',
          processDone: '已选定',
        },
        photoGuide: {
          outputs: {
            eyebrow: '你会得到什么',
            sourceLabel: '上传原图',
            avatarTitle: '3D 数字人',
            backgroundTitle: '16:9 背景',
            finalTitle: '最终效果',
            expectTitle: '预期效果',
            expect: {
              drive: '任意语言音频驱动 · 口型同步',
              expression: '表情自然 · 主体稳定',
              fidelity: '保留原图人物特征',
              body: '身体固定 · 无肢体动作',
            },
          },
          mobileSummary: {
            title: '你将得到两个配套产物',
            body: '一个 3D 数字人 + 一张基于原图场景生成的 16:9 背景，组合后由音频驱动使用。创建约需 3–4 小时。',
          },
          rules: {
            title: '上传前必须满足',
            compactTitle: '照片要点',
            tabReal: '真人照片',
            tabStylized: '卡通人物',
            real: {
              framing: '头像或上半身，人物居中留有边距，完整头部不可裁切',
              facing: '正面看镜头，身体偏转不超过 25°，头部保持端正',
              subject: '仅一个成人主体，脸部、颈部和肩部清晰无遮挡',
            },
            stylized: {
              scope: '仅一个具有人类结构的卡通角色；不支持动物、玩偶等非人类主体',
              features: '脸型与五官结构接近真人，避免夸张圆脸或过大的眼睛',
              framing: '头像或上半身构图，人物居中、正面，完整头部可见',
            },
          },
          examples: {
            goodBadge: '推荐',
            avoidBadge: '避免',
            short: {
              real: {
                good: '推荐构图',
                crop: '头部被截断',
                side: '明显侧脸',
                occlusion: '面部遮挡',
              },
              stylized: {
                good: '推荐范例',
                nonhumanAnimal: '动物主体',
                nonhumanRobot: '机器人主体',
                face: '五官非人化',
              },
            },
            real: {
              good: '推荐构图：居中正面，头部与颈肩完整清晰',
              crop: '头部被画框截断——系统需要凭空补全缺失部分',
              side: '明显侧脸——转正需重建看不见的一侧，容易改变人物长相',
              occlusion: '手托脸遮住脸颊下颌——移除遮挡需要重建脸部细节',
            },
            stylized: {
              good: '具有人类结构的卡通角色，居中正面',
              nonhumanAnimal: '动物等非人类主体不支持',
              nonhumanRobot: '机器人、机甲等非人类主体不支持',
              face: '五官比例过度非人化——过大的眼睛、过简的鼻子或嘴',
            },
          },
          details: {
            toggle: '更多建议',
            real: {
              lens: { title: '原图与镜头', body: '优先使用高清原始照片（短边 1080px 以上），避免视频截帧、近距离自拍和广角畸变。' },
              faceLight: { title: '脸部与光线', body: '保留自然皮肤纹理与眼神光；光线柔和均匀，避免强阴影、过曝和重度磨皮。' },
              clothing: { title: '衣物与配饰', body: '避免耳颈配饰、复杂花纹和编织纹理明显的衣物。' },
              handsBackground: { title: '手部与背景', body: '手部尽量不入镜；背景透视合理，光源方向和色调与人物一致。' },
            },
            stylized: {
              features: { title: '五官比例', body: '眼睛大小与形状接近真人，使用人类结构的鼻型和有体积感的唇形。' },
              outline: { title: '轮廓与遮挡', body: '完整头部、脸部与颈肩清晰可见，不被碎发或物体遮挡。' },
              originality: { title: '原创与 IP', body: '优先使用原创角色，避免知名动漫、影视或游戏 IP。' },
              lightBackground: { title: '光线与背景', body: '人物光线均匀；原图背景与人物的光源方向、色调一致。' },
            },
          },
        },
        upload: {
          headline: '上传一张照片',
          subline: '点击或拖拽到这里 · 支持 JPG 或非透明 PNG · 最大 10MB · 短边最低 340px，推荐 1080px 以上',
          processNote: '上传后会先检查照片，有问题会先提示你，不会直接创建或产生消耗。',
          notAnImage: '请选择图片文件',
          unsupportedFormat: '请上传 JPG 或 PNG 格式的图片',
          transparentPng: '暂不支持带透明背景的 PNG，请导出为不透明背景后再上传',
          tooLarge: '图片大小不能超过 10MB',
        },
        detect: {
          eyebrow: '照片检测',
          headline: '正在检测照片',
          previewAlt: '上传预览',
          waitingSubline: '正在等待检测结果...',
          finalCheck: '最终检查',
          waitingShort: '等待结果',
          checking: '检查中',
          rowChecked: '已检查',
          row: {
            image_quality: '图像质量',
            face_detection: '人脸检测',
            subject_verification: '主体验证',
            lighting_occlusion: '光线与遮挡',
            composition: '构图',
          },
        },
        report: {
          eyebrow: '检测结果',
          headline: '有几处需要调整',
          subline: '照片还没达到数字人重建标准，确认后我们来处理。',
          confirmButton: '开始处理',
          reuploadButton: '换一张照片',
          action: {
            'crop': '裁切至标准构图',
            'cleanup': '清理背景与光线',
            'pose-fix': '调整姿态',
            'reframe': '重新构图',
            'occlusion-fix': '去除遮挡',
          },
        },
        process: {
          eyebrow: '准备素材',
          eyebrowChoice: '选择图像',
          eyebrowFinalizing: '准备背景',
          headlineDual: '正在准备两个版本',
          headlineSingle: '正在精修这张照片',
          headlineGenerateCompare: '正在生成 AI 版本',
          sublineDual: '两个版本都完成后会一起展示，供你对比选择。',
          sublineGenerateCompare: '原图已达标，生成完成后一起对比选择。',
          refinedFallbackRow: '标准化处理',
          rowNone: '无需任何处理',
          generationWorking: 'AI 生成中',
          generationWorkingSub: '按数字人最佳标准重绘',
          refinedWorking: '微调中',
          refinedWorkingSub: '在原片上逐项修正',
          generationStep: {
            analyze: '分析构图与画质',
            redraw: '重绘人物形象',
            verify: '质量校验',
          },
          track: {
            ready: '已就绪',
            originalReady: '已达标',
            stillWorking: '仍在处理中',
            failedShort: '本次未成功',
            failedSub: '原因会在结果页说明',
          },
          row: {
            'crop': '裁切至标准构图',
            'cleanup': '清理背景与光线',
            'pose-fix': '调整姿态',
            'reframe': '重新构图',
            'occlusion-fix': '去除遮挡',
          },
          variant: {
            refined: {
              title: '微调版',
              desc: '在你的原图上小幅修正，最大程度保留原有效果。',
            },
            generated: {
              title: 'AI 生成版',
              desc: '按数字人最佳标准重新生成，重建成功率与效果更稳。',
            },
            original: {
              title: '原图',
              desc: '已通过全部检查，保持你上传的原样。',
            },
          },
          choice: {
            headline: '选择你想用的版本',
            subline: '两个版本各有优势，选中的将用于继续创建数字人。',
            headlineSingle: '确认处理结果',
            sublineSingle: '确认后将用这张照片继续创建数字人。',
            headlineOneMade: '只有一个版本完成了',
            sublineOneMade: '另一个版本未能完成，原因见卡片；用完成的这版继续即可，不影响创建。',
            headlineBothFailed: '两个版本都没能完成',
            sublineBothFailed: '本次处理没能产出可用结果。重试不会消耗 Avatar Creations。',
            retryButton: '重试处理',
            slotFailed: '未能完成',
            confirmButton: '用这张继续',
            confirmButtonSingle: '满意，继续',
            zoom: '放大查看',
            zoomClose: '关闭预览',
          },
          trackFail: {
            processing_error: '处理过程出错，没能产出这个版本',
            quality_gate: '生成结果未通过质量校验，已自动放弃',
            content_policy_sexual: '图片可能包含裸露或成人内容，请更换图片',
            content_policy_violence_dangerous: '图片可能包含暴力、危险或其他不适宜内容，请更换图片',
            content_policy_hate_harassment: '图片可能触发仇恨或骚扰内容规则，请更换图片',
            content_policy_child_safety: '图片可能触发未成年人安全规则，请更换图片',
            content_policy_privacy: '图片可能包含敏感个人信息，请更换图片',
            content_policy_ip: '图片可能触发版权或受保护内容规则，请更换图片',
            content_policy_other: '图片可能触发内容安全规则，请更换图片',
            input_invalid: '图片无法读取、格式不受支持或尺寸不符合要求，请重新上传',
            input_unavailable: '暂时无法读取这张图片，请重新上传或稍后再试',
            model_no_output: '当前图片未能生成可用结果，请更换一张人物主体更清晰的图片',
            provider_busy: '处理服务暂时繁忙，请稍后重试，无需更换图片',
            provider_configuration: '处理服务暂时不可用，我们正在处理，请稍后再试',
            output_invalid: '生成结果未能通过格式校验，请稍后重试',
          },
          finalizing: {
            title: '提取背景中',
            tileSub: '匹配数字人参数',
            subline: '通常需要 1 分钟左右，完成后确认效果并命名。',
          },
        },
        restore: {
          title: '正在恢复上次的进度',
          subline: '检测到你上次的照片处理任务，正在读取它的最新进度，不会产生任何消耗。',
          goneToast: '上次的处理任务已不存在，请重新上传照片开始。',
          unavailableToast: '暂时无法读取上次的处理进度，下次打开本页会再次尝试。',
        },
        systemError: {
          title: '出错了，请重试',
          subline: '处理服务出现异常，请用同一张照片重试，或者换一张照片重新上传。',
          notYourFault: '这是我们的问题，重试不会消耗 Avatar Creations。',
          createUnknownTitle: '无法确认照片处理是否已经开始',
          createUnknownSubline: '请求发出后等待超时，自动重试可能会创建重复的处理任务。',
          createUnknownNote: '仅在你希望新建处理任务时，才重新上传这张照片。',
          taskUnavailableTitle: '当前照片处理任务已不可用',
          taskUnavailableSubline: '服务已无法读取这个任务，请重新上传照片并创建新的处理任务。',
          taskUnavailableNote: '本次不会消耗 Avatar Creation。',
          retryButton: '重试',
          retryingButton: '正在重新连接…',
        },
        completion: {
          eyebrow: '准备背景',
          headlineDefault: '看起来很棒！',
          headlineCropped: '我们帮你调整了构图',
          headlineAdjusted: '看起来很棒！',
          sublineDefault: '现在给你的数字人取个名字。',
          sublineCropped: '画面已自动调整，现在给数字人取个名字。',
          sublineWithBackground: '数字人照片与背景已就绪，确认效果后取个名字。',
          finalAlt: '处理后的照片',
          characterLabel: '数字人照片',
          backgroundLabel: '数字人背景',
          backgroundAlt: '数字人背景',
          backgroundFailed: '背景暂未就绪',
          backgroundFailedHint: '不影响创建数字人，创建后系统会继续补全背景。',
          backgroundPending: '背景加载中',
          ownershipNote: '创建的数字人属于你的个人资产，仅你的账号可见可用，Spatius 不会公开或另作他用。',
          readyBadge: '已就绪',
        },
        discard: {
          action: '换一张照片',
          title: '放弃当前处理？',
          description: '当前的处理进度、结果和已填写内容都会被丢弃。Avatar Creations 不会被消耗。',
          confirm: '放弃并重新上传',
          escape: '放弃，重新上传',
        },
        reject: {
          reuploadButton: '换一张照片',
          reason: {
            unreadable_image: '无法读取这张图片',
            low_resolution_pre: '图片分辨率过低',
            low_resolution: '图片分辨率过低',
            file_too_large: '图片体积过大',
            unsupported_format: '不支持的图片格式',
            face_too_small: '人脸太小了',
            no_face: '没有检测到人脸',
            multiple_faces: '画面中有不止一张脸',
            multiple_humans_llm: '画面中有不止一个人',
            non_human_subject: '主体不是真人',
            no_human_subject: '没有检测到人物',
            minor_child: '画面中是未成年人',
            infant_toddler: '画面中是婴幼儿或婴幼儿比例的形象',
            extreme_lighting: '光线过强或过暗',
            occlusion: '面部被遮挡',
            content_sexual: '照片包含暴露或成人内容',
            content_minor: '照片可能涉及未成年人安全问题',
            content_violence: '照片包含暴力、血腥或其他危险内容',
            content_other: '照片可能包含不适宜内容',
            unknown: '这张照片未通过检测',
          },
          recovery: {
            unreadable_image: '换一张能正常打开的图片再试。',
            low_resolution_pre: '使用短边至少 340 像素的照片。',
            low_resolution: '使用短边至少 340 像素的照片。',
            file_too_large: '换一张体积小于 10 MB 的图片。',
            unsupported_format: '使用 JPG 或非透明 PNG 格式的图片。',
            face_too_small: '靠近镜头一些，或者用更高分辨率的照片。',
            no_face: '使用一张正面、清晰的肖像照。',
            multiple_faces: '请只保留一个人在画面里。',
            multiple_humans_llm: '请使用单人画面。',
            non_human_subject: '数字人需要真人肖像。',
            no_human_subject: '请使用一张人物照片。',
            minor_child: '数字人必须是成年人。',
            infant_toddler: '数字人需要成年人，或五官比例接近真人的卡通角色。',
            extreme_lighting: '换到光线均匀的环境再拍一张。',
            occlusion: '请取下面部的口罩、墨镜或其他遮挡物。',
            content_sexual: '请换一张穿着日常服装的照片。',
            content_minor: '请换一张成年人穿着日常服装的照片。',
            content_violence: '请换一张日常的肖像照。',
            content_other: 'AI 无法处理这张照片，请换一张正面、穿着日常服装的照片。',
            unknown: '请换一张正面、清晰的肖像照再试。',
          },
        },
      },
    },
    library: {
      subtitle: '浏览和探索公共角色库',
    },
  },
  onboardingSurvey: {
    title: '花 30 秒告诉我们你的情况',
    description: '每道题都可以跳过，答几道都行，这能帮我们把 Studio 做得更贴近你的需求。',
    optional: '选填',
    otherPlaceholder: '请补充说明',
    answered: '已回答 {count} / {total} 题',
    skip: '跳过',
    submit: '提交',
    progress: '第 {current} / {total} 题',
    chooseOne: '选择一项，也可以修改或取消。',
    chooseMany: '可以选择多个选项。',
    optionalNote: '每道题都可以跳过',
    continue: '继续',
    skipQuestion: '跳过此题',
    back: '返回',
    submitEarly: '提交已答',
    closeSurvey: '结束问卷',
    close: '关闭问卷',
    otherLabel: '补充说明（选填）',
    thankYouTitle: '感谢你的反馈！',
    thankYouDescription: '你的回答会帮助我们持续改进 Studio。',
    startUsing: '开始使用',
    autoClose: '{seconds} 秒后自动关闭',
  },
  page: {
    avatarPagination: {
      label: '人物分页',
      previous: '上一页',
      next: '下一页',
      position: '第 {page} / {total} 页',
      currentPage: '第 {page} 页',
      goToPage: '前往第 {page} 页',
    },
    library: libraryPage.zhCN,
    custom: customPage.zhCN,
    apps: appsPage.zhCN,
    usage: usagePage.zhCN,
    billing: billingPage.zhCN,
    account: accountPage.zhCN,
    auth: authPage.zhCN,
    integrate: integratePage.zhCN,
    utility: utilityPage.zhCN,
    notifications: notificationsPage.zhCN,
    support: supportPage.zhCN,
  },
  shell: {
    breadcrumbs: '面包屑导航',
    appDetails: '应用详情',
    avatarDetails: '角色详情',
    studio: 'Studio',
    collapse: '收起侧栏',
    expand: '展开侧栏',
    openNavigation: '打开导航',
    closeNavigation: '关闭导航',
    mainNavigation: '主导航',
    modules: 'Studio 模块',
    creditsRemaining: '剩余额度',
    creditsOf: '剩余 {value} / {total} 额度',
    creditsAvailable: '剩余 {value} 额度',
    creditsUnavailable: '余额不可用',
    creditsLoading: '正在加载余额…',
    runningLow: '额度即将用尽',
    noneLeft: '额度已用尽',
    managePlan: '管理套餐',
    viewCredits: '查看额度用量',
    accountMenu: '打开账户菜单',
    signOut: '退出登录',
  },
  dashboard: {
    accountOverview: '方案与支持',
    tickets: { title: '处理中的工单', list: '处理中的工单列表', open: '打开工单：{title}', unread: '有未读更新' },
    welcome: '欢迎使用 Studio',
    welcomeBack: '欢迎回来，{name}',
    period: '{range} · 最近 7 天 · UTC',
    loadFailed: '工作区暂不可用',
    loadFailedHint: '数据可用后，你的数字人和活动会显示在这里',
    gallery: {
      title: '试试数字人',
      browse: '浏览数字人',
      previous: '上一组数字人',
      next: '下一组数字人',
      group: '公共数字人',
      action: '试聊',
    },
    integration: {
      title: '把数字人接进你的应用',
      continueTitle: '继续你的接入',
      description: '通过 SDK 四步完成接入',
      action: '开始接入',
      continueAction: '继续接入',
      stepsLabel: '接入步骤',
      steps: {
        choose: { title: '选择数字人', hint: '选一个公共数字人或你创建的数字人' },
        key: { title: '获取 API Key', hint: '拿到应用 ID 和第一个 API Key' },
        build: { title: '开始构建', hint: '运行示例，或在 Web、iOS、Android 接入 SDK' },
        verify: { title: '验证接入', hint: '在用量页看到第一批会话' },
      },
    },
    metrics: {
      open: '在用量页查看{metric}',
      connectionTime: '连接时长',
      connectionTimeHint: '所有应用合计',
      sessions: '会话数',
      sessionsHint: '本周期合计',
      peak: '峰值并发',
      peakHint: '同一时刻的连接数',
      live: '实时连接',
      liveHint: '当前在线',
      slots: '/ {count} 个名额',
    },
    chart: {
      title: '连接活动',
      caption: '每日连接时长 · 所有应用',
      unit: '分钟',
      totalLabel: '周期合计',
      empty: '本周期暂无数据',
      emptyHint: '发起一次会话后，这里会显示用量',
      open: '在用量页查看连接活动',
    },
    balance: {
      label: '可用余额',
      credits: '用量额度',
      creditsUnit: '额度',
      creations: '数字人创建次数',
      creationsUnit: '次',
      runningLow: '即将用尽',
      noneLeft: '已用尽',
      unavailable: '不可用',
      remaining: '剩余 {value} / {total} {unit}',
    },
    recent: {
      title: '最近使用',
      hint: '来自你的会话 · 最近 90 天',
      tryTitle: '试试数字人',
      tryHint: '和公共数字人开始一段对话',
      publicAvatar: '公共数字人',
      customAvatar: '自定义数字人',
      open: '打开数字人',
      lastConnected: '最近连接 {time} UTC',
      create: '创建数字人',
    },
    copy: {
      copyId: '复制 {name} 的数字人 ID',
      copiedId: '已复制 {name} 的数字人 ID',
      copied: '已复制',
    },
  },
  stats: {
    title: '用量统计',
    subtitle: '查看 API 用量、会话记录和 Avatar Creations 使用情况。',
    tabs: {
      overview: '概览',
      sessionHistory: '会话记录',
      avatarCreations: 'Avatar Creations',
    },
    timeRange: {
      'today': '今天',
      '7d': '近 7 天',
      '14d': '近 14 天',
      '30d': '近 30 天',
      '90d': '近 90 天',
      '1y': '近 1 年',
    },
    usage: {
      title: '连接用量',
      total: '总时长',
      chart: '连接时长趋势',
      unit: {
        hours: '小时',
        minutes: '分钟',
        seconds: '秒',
      },
    },
    session: {
      title: '连接数',
      total: '总连接数',
      chart: '连接数趋势',
      unit: '次',
      maxConcurrent: '峰值并发连接',
    },
    realtime: {
      title: '实时连接数',
    },
    noData: '暂无数据',
    noDataHint: '开始一个会话即可在此查看用量数据',
    noDataCreateKey: '创建 API Key',
    noDataViewDocs: '查看文档',
    loading: '加载中...',
    fetchFailed: '获取统计数据失败',
  },
  connectionLogs: {
    title: '连接日志',
    loading: '加载中...',
    noData: '暂无连接日志',
    fetchFailed: '获取连接日志失败',
    filter: {
      allApps: '全部应用',
      deleted: '已删除',
    },
    table: {
      connectedAt: '连接时间',
      disconnectedAt: '断开时间',
      duration: '时长',
      appId: 'App ID',
      avatarId: 'Avatar ID',
      region: '区域',
      active: '活跃中',
    },
    pagination: {
      showing: '第 {from}-{to} 条，共 {total} 条',
      prev: '上一页',
      next: '下一页',
    },
  },
  feedback: {
    myTickets: '我的工单',
    submitFeedback: '提交反馈',
    submitDescription: '提交反馈和问题，我们会尽快处理',
    ticketDetail: '工单详情',
    noTickets: '暂无工单',
    noTicketsDescription: '提交反馈，我们会尽快处理',
    category: '问题分类',
    title: '标题',
    description: '问题描述',
    platforms: '接入平台',
    integrationModes: '接入模式',
    status: '状态',
    createdAt: '创建时间',
    reply: '回复',
    sendReply: '发送回复',
    closeTicket: '关闭工单',
    closeConfirm: '确认关闭此工单？关闭后将无法再回复。',
    ticketClosed: '此工单已关闭',
    toastCreateSuccess: '工单创建成功',
    toastUpdateSuccess: '工单更新成功',
    toastCloseSuccess: '工单已关闭',
    toastReplySuccess: '回复发送成功',
    toastCreateFailed: '创建工单失败',
    toastListFailed: '获取工单列表失败',
    toastDetailFailed: '获取工单详情失败',
    toastUpdateFailed: '更新工单失败',
    toastCloseFailed: '关闭工单失败',
    toastReplyFailed: '发送回复失败',
    replyPlaceholder: '输入回复内容...',
    titlePlaceholder: '简要描述您遇到的问题',
    descriptionPlaceholder: '详细描述问题，包括复现步骤、预期行为等',
    submit: '提交',
    cancel: '取消',
    back: '返回',
    admin: '客服',
    me: '我',
    noReplies: '暂无回复',
    noRepliesDescription: '我们会尽快处理您的反馈',
    statusPending: '待处理',
    statusInProgress: '处理中',
    statusReplied: '已回复',
    statusClosed: '已关闭',
    categorySdkIntegration: 'SDK 集成问题',
    categoryApiError: 'API 调用异常',
    categoryDocsUnclear: '文档不清晰',
    categoryBilling: '计费问题',
    categoryAvatar: 'Avatar',
    categoryOther: '其他',
    platformWeb: 'Web',
    platformIos: 'iOS',
    platformAndroid: 'Android',
    platformFlutter: 'Flutter',
    integrationDirectMode: '直连模式',
    integrationBackendMode: '后端模式',
    integrationLiveKitAgents: 'LiveKit Agents 集成',
    integrationAgoraConvo: 'Agora Convo AI / TEN Framework 集成 Beta',
    integrationBackendModeWithLiveKit: '后端模式（LiveKit 传输）',
    needHelp: '需要帮助？',
    needHelpDescription: '提交反馈工单，我们会尽快回复',
    newTicket: '提交工单',
    viewMyTickets: '查看我的工单',
    statusFilter: '状态筛选',
    all: '全部',
    categoryRequired: '请选择问题类别',
    titleRequired: '请输入标题',
    descriptionRequired: '请输入问题描述',
    ticketNotFound: '工单不存在',
    backToList: '返回列表',
    replyHistory: '回复记录',
    send: '发送',
    confirmClose: '确认关闭',
    welcomeTitle0: '嘿，我在这儿',
    welcomeTitle1: '有话跟我说？',
    welcomeTitle2: '需要支援吗？',
    welcomeTitle3: '遇到问题了？',
    welcomeMessage0: '接入遇到坑了？别憋着，甩过来我们帮你搞定',
    welcomeMessage1: '不管是 bug 还是建议，我们都想听听',
    welcomeMessage2: '工程师在线等你提问，别客气',
    welcomeMessage3: '有任何疑问都可以提工单，我们会尽快回复',
    integrationHint0: '接入卡住了？丢个工单过来，工程师在线等',
    integrationHint1: 'API 报错？SDK 异常？提个工单我们帮你排查',
    integrationHint2: '文档没看懂？别硬撑，提个工单问我们',
    integrationHint3: '集成有问题？我们的工程师随时待命',
    recentTickets: '工单动态',
    viewAll: '查看全部',
    noTicketsYet: '一切顺利',
    noTicketsHint: '还没遇到问题？那太好了！有任何疑问随时找我们',
    gotIt: '收到！',
  },
  pricing: {
    subtitle: '选择适合您的定价方案',
    title: '定价方案',
    description: '根据您的使用需求选择合适的方案',
    monthlyPlan: '月付',
    annualPlan: '年付',
    annualBillingNote: '按年支付 {price}',
    save20: '节省 20%',
    contactUs: '联系我们',
    usageDisclaimer: '使用说明：所有方案包含每月使用限额。如需超出限额，请联系我们获取定制价格：',
    comingSoon: '支付功能即将上线',
    alreadySubscribed: '您已订阅该方案或更高级别的方案。',
    payment: {
      paymentSuccessful: '支付成功！您的订阅已激活。',
      paymentCanceled: '支付已取消。您可以随时重试。',
      failedToCreatePayment: '创建订阅失败，请重试。',
      downgradeScheduled: '方案变更已安排，将于 {date} 生效。',
      downgradeScheduledGeneric: '方案变更已安排，将在当前计费周期结束时生效。',
      cancelScheduled: '您的订阅将在当前计费周期结束时取消。',
    },
    downgrade: {
      confirmTitle: '确认降级',
      confirmDescription: '确定要降级到 {plan} 吗？此更改将在当前计费周期结束后生效。',
      confirm: '确认降级',
    },
    comparison: {
      title: '方案对比',
      monthlyCredits: '每月额度',
      perMinuteRate: '每分钟费率',
      concurrentSessions: '最大并发会话',
      sessionDuration: '最大会话时长',
      avatarUnits: 'Avatar Creations',
      avatarUnitsValue: '首月 {first} 个 · 续费 {monthly} 个/月',
      avatarUnitsValueSame: '{count} 个/月',
      avatarUnitsValueOneTime: '{count} 个一次性赠送',
      avatarUnitsNone: '—',
      unlimited: '无限制',
    },
    cardFeatures: {
      avatarUnitsSplit: '首月赠送 {first} 个 Avatar Creation · 续费每月 {monthly} 个',
      avatarUnitsSame: '每月赠送 {count} 个 Avatar Creation',
      avatarUnitsOneTime: '一次性赠送 {count} 个 Avatar Creation',
    },
    avatarCreationsAlternative: {
      title: '只想单独购买 Avatar Creations？',
      description: '无需更改订阅方案，即可购买永久有效的一次性 Avatar Creations 套餐。',
      action: '购买 Avatar Creations',
    },
  },
  notifications: {
    eyebrow: '消息中心',
    title: '通知',
    summary: '{count} 条未读通知',
    allCaughtUp: '所有通知都已读完。',
    unreadCount: '{count} 条未读',
    resultCount: '共 {count} 条',
    viewAll: '查看全部',
    markAllRead: '全部标为已读',
    loadMore: '加载更多',
    loadFailed: '暂时无法加载通知',
    retryHint: '请检查网络连接后重试。',
    emptyRecent: '暂时没有新通知',
    bell: {
      label: '通知',
      unreadLabel: '通知，{count} 条未读',
      subtitle: '账户与业务动态',
    },
    filters: {
      label: '通知筛选',
      all: '全部',
      unread: '未读',
    },
    empty: {
      all: { title: '暂无通知', body: '重要的账户与业务动态会出现在这里。' },
      unread: { title: '没有未读通知', body: '你已经读完了所有通知。' },
    },
    events: {
      welcome: { title: '欢迎使用 Spatius Studio', body: '账户已经准备就绪，开始创造精彩体验吧。' },
      avatarReady: { title: '数字人已创建完成', body: '{avatarName} 已处理完成，可以开始使用。' },
      avatarFailed: { title: '数字人创建失败', body: '{avatarName} 未能完成创建，对应的 Avatar Creation 已退回。' },
      feedbackReceived: { title: '反馈已收到', body: '我们已收到 {ticketNo}：{title}' },
      feedbackReply: { title: '客服有新回复', body: '{ticketNo}：{replyPreview}' },
      autoReloadSucceeded: { title: 'Credits 自动充值成功', body: '已增加 {creditsAdded} credits，当前余额为 {newBalance}。' },
      autoReloadDisabled: { title: '自动充值已停用', body: '多次付款失败后，系统已停用自动充值。请检查付款设置。' },
      lowBalance: { title: 'Credits 余额不足', body: '当前余额为 {currentBalance}，已低于 {threshold} credits 的提醒线。' },
      unknown: { title: '账户有新动态', body: '你的 Spatius Studio 账户有一条新动态。' },
    },
  },
  avatarUnits: {
    sectionTitle: 'Avatar Creations',
    sectionSubtitle: '创建 1 个数字人消耗 1 个 Avatar Creation。购买的 Avatar Creations 永久有效。',
    policyNote: '提交创建时扣除；创建失败自动退回；创建成功后删除数字人不退回。',
    usageDescription: '前往用量页面查看余额、有效期和流水记录。',
    balance: '剩余 {count} 个 Avatar Creation',
    balanceUnavailable: '余额暂不可用',
    expiringSoon: '{count} 个 Avatar Creation 即将过期',
    viewUsage: '查看用量',
    viewPlans: '查看订阅方案',
    purchasing: '跳转付款中...',
    package: {
      units: '{count} 个 Avatar Creation',
      perUnit: '约 {price}/Avatar Creation',
    },
    validity: {
      permanent: '永久有效',
      expiresAt: '{date} 过期',
      expiringSoon: '即将过期',
      expired: '已过期',
      valid: '有效',
    },
    source: {
      register: '注册赠送',
      subscriptionFirst: '首次订阅',
      subscriptionRenewal: '订阅续费',
      subscriptionUpgrade: '订阅升级',
      purchase: '购买',
      manualGrant: '人工发放',
      refund: '失败退回',
    },
    changeType: {
      grant: '获得',
      consume: '消耗',
      expire: '过期',
      refund: '退回',
    },
    checkout: {
      canceled: '付款已取消。您可以重新选择套餐后再试。',
      processing: '支付成功，正在更新您的 Avatar Creations 余额...',
      confirmed: 'Avatar Creations 已到账。',
      delayed: '暂时无法确认余额更新。请稍后刷新；如果仍未到账，请联系支持团队。',
      startFailed: '暂时无法发起付款，请稍后重试。',
    },
    createGate: {
      loadingTitle: '正在检查 Avatar Creations',
      loadingDescription: '正在确认当前可用的 Avatar Creations。',
      errorTitle: '暂时无法确认 Avatar Creations',
      errorDescription: '当前无法确认你的可用 Avatar Creations，请重试后再上传照片。',
      emptyTitle: '没有可用的 Avatar Creations',
      emptyDescription: '创建数字人需要 {cost} 个 Avatar Creation。订阅方案会定期提供 Avatar Creations，方便持续创建数字人。',
      pendingTitle: '正在更新 Avatar Creations',
      pendingDescription: '支付已收到，余额正在更新中，通常只需要一点时间。',
      availableLine: '当前可用 {available} 个 Avatar Creation · 最终创建时将消耗 {cost} 个。',
      finalUseLine: '创建将消耗 {cost} 个 Avatar Creation · 当前 {available} 个可用',
      finalBalanceLine: '当前可用 {available} 个 Avatar Creation',
      refreshBalance: '刷新余额',
      contactForFreeUnits: '联系获取免费 Avatar Creations',
      contactSubject: 'Avatar Creations 试用申请',
      contactPrefix: '如需试用支持、企业采购或特殊帮助，请联系 ',
      contactSuffix: '。',
      concurrentLimit: '当前已有数字人正在创建中，请稍后再试。',
      unknownResultTitle: '需要确认创建状态',
      unknownResultDescription: '这次创建请求可能已经到达服务端。请先到自定义角色查看，避免重复提交同一个数字人。',
      viewPersonal: '查看自定义角色',
    },
    historyPage: {
      title: 'Avatar Creations',
      description: '查看剩余 Avatar Creations、有效期和流水记录。',
      tabBatches: '到期明细',
      tabTransactions: '流水明细',
      availableUnitsLabel: '可用 Avatar Creations',
      emptyGrants: '暂无可用 Avatar Creations。',
      emptyTransactions: '暂无流水记录。',
      remaining: '剩余 {count} / {total}',
      unitsCol: 'Creations',
      sourceCol: '来源',
      validityCol: '有效期',
      timeCol: '时间',
      changeCol: '变动',
      balanceAfterCol: '变动后余额',
      backToLibrary: '返回数字人列表',
      balanceLoadFailed: '暂时无法加载 Avatar Creations 余额。',
      loadMore: '加载更多',
    },
    buyPage: {
      title: '购买 Avatar Creations',
      description: '选择 Avatar Creations 套餐来创建更多数字人。购买的 Avatar Creations 永久有效，Free、Starter 和 Scale 用户都可以购买。',
      currentBalance: '当前余额',
      units: '个 Avatar Creation',
      purchaseNote: 'Avatar Creations 只会在最终提交创建数字人时消耗。',
      emptyPackages: '暂无可购买的 Avatar Creations 套餐。',
      popular: '热门',
      selectHint: '请选择一个套餐继续。',
      selected: '已选择 {count} 个 Avatar Creation · {price}',
      checkout: '前往付款',
      createAvatar: '创建数字人',
      backToUsage: '返回用量',
    },
  },
}
